import {produce} from 'immer';

import {
  PanelBankSearchHistoryItem,
  PanelBankSettings,
} from '../PanelBank/types';

const MAX_ITEMS_IN_HISTORY = 10;

export const produceSearchHistory = (
  newQuery: string,
  panelBankConfigSettings: PanelBankSettings,
  maxItemsInHistory = MAX_ITEMS_IN_HISTORY
): PanelBankSearchHistoryItem[] | undefined => {
  if (newQuery === '') {
    return panelBankConfigSettings.searchHistory;
  }
  if (!panelBankConfigSettings.searchHistory) {
    return [{query: newQuery}];
  }
  // look for history first
  // note that a race condition is possible
  const searchHistory = produce(
    panelBankConfigSettings.searchHistory,
    draftHistory => {
      const matchIdx = draftHistory.findIndex(item => item.query === newQuery);
      if (matchIdx === 0) {
        return draftHistory;
      }

      if (matchIdx > 0) {
        // remove existing item from the list
        draftHistory = [
          ...draftHistory.slice(0, matchIdx),
          ...draftHistory.slice(matchIdx + 1, maxItemsInHistory),
        ];
      }

      if (draftHistory.length >= maxItemsInHistory) {
        draftHistory = draftHistory.slice(0, maxItemsInHistory - 1);
      }

      // add new item to beginning of list
      return [{query: newQuery}, ...draftHistory];
    }
  );
  return searchHistory;
};
